const encodeItem = (item) => {
    return JSON.stringify(item);
};
const decodeItem = (item, schema) => {
    const decodedItem = JSON.parse(item);
    const parseResult = schema.safeParse(decodedItem);
    return parseResult.success ? parseResult.data : undefined;
};
export const createValueStorage = (key, schema, storage = localStorage) => {
    return {
        get: () => {
            const item = storage.getItem(key);
            return item !== null ? decodeItem(item, schema) : undefined;
        },
        set: (item) => {
            const data = encodeItem(item);
            storage.setItem(key, data);
        },
        remove: () => {
            storage.removeItem(key);
        },
    };
};
